import React, { FC } from 'react';
import { RootState } from '../store';
import { useSelector } from 'react-redux';
import { DeviceType, Platform, WriteDirection } from 'sofa-reborn-react';
import RotationIcon from '../components/RotationIcon';

const getTop = (platform: Platform, deviceType: DeviceType): string => {
	let headerHeight = 0;
	const elements = Array.from(
		document.getElementsByClassName('header'),
		(header) => header as HTMLElement
	);
	for (const element of elements) {
		if (element && element.offsetHeight) {
			headerHeight = element.offsetHeight;
		}
	}
	const offset =
		platform === 'kiosk' || deviceType === 'mobile' || deviceType === 'tablet' ? 32 : 16;
	return headerHeight + offset + 'px';
};

const getLeft = (deviceType: DeviceType): string => {
	let sceneWidth = 0;
	if (deviceType === 'mobile' || deviceType === 'tablet') {
		const rotationIconWidth = deviceType === 'mobile' ? 98 : 114;
		sceneWidth = window.innerWidth / 2 - rotationIconWidth / 2;
	} else {
		const clientWidth = document.getElementById('scene')?.clientWidth;
		const leftOfScene = document.getElementById('scene')?.getBoundingClientRect().left || 0;
		sceneWidth = clientWidth ? clientWidth / 2 + leftOfScene : 0;
	}
	return sceneWidth + 'px';
};

const RotationIconContainer: FC = () => {
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const showRotationIcon = useSelector<RootState, boolean>((state) => state.scene.showRotationIcon);

	return (
		<RotationIcon
			deviceType={deviceType}
			writeDirection={writeDirection}
			platform={platform}
			top={getTop(platform, deviceType)}
			left={getLeft(deviceType)}
			showRotationIcon={showRotationIcon}
		/>
	);
};

export default RotationIconContainer;
